
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementSelector } from "../../../library-js/dom-tools/ElementSelector";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnChange, OnInput } from "../../../library-js/dom-tools/EventListeners";
import { Rokojori } from "../../js/Rokojori";
import { GodotCommands } from "./Godot/GodotCommands";
import { InputDeviceTypes } from "./InputDeviceType";
import { ModifierKey, ModifierKeys } from "./ModifierKey";
import { Platform } from "./PlatformCommandInteraction";

class ProcessedActionElement extends Element
{
  _action:string;
}

export class AppCommandElements
{
  static godotCommands:GodotCommands = new GodotCommands();

  static readonly godotCommand = new ElementType( "godot-command" );
  static readonly inputAction  = new ElementType( "input-action" );
  static readonly deviceAttribute   = new ElementAttribute( "device" ); 
  static readonly actionAttribute   = new ElementAttribute( "type" ); 
  static readonly keyboardInputUnion = new ElementType( "keyboard-input-union" );
  static readonly profileSelection = new ElementType( "profile-selection" ); 
  static readonly selectionPanel = new ElementType( "selection-panel" );
  static readonly commands = new ClassFlag( "commands" ); 
  static readonly platform = new ClassFlag( "platform" ); 

  static applyOnDocument()
  {
    AppCommandElements.profileSelection.forAllInDoc( e => AppCommandElements.applySelection( e ) );

    AppCommandElements.applyCommands();
    
  }

  static applyCommands()
  {
    AppCommandElements.godotCommand.forAllInDoc( e => AppCommandElements.applyGodotOnElement( e ) );
  }

  static applySelection( e:Element )
  {
    let godot = e.closest( ".godot" );

    let selectionsPanels = AppCommandElements.selectionPanel.queryAll( e ) ;
     
    let commandsProfileSelection:HTMLSelectElement = null;
    let platformSelection:HTMLSelectElement = null;

    for ( let i = 0; i < selectionsPanels.length; i++ )
    {
      if ( AppCommandElements.commands.in( selectionsPanels[ i ] ) )
      {
        commandsProfileSelection = ElementType.select.query( selectionsPanels[ i ] );
      }

      if ( AppCommandElements.platform.in( selectionsPanels[ i ] ) )
      {
        platformSelection = ElementType.select.query( selectionsPanels[ i ] );
      }
    }

    console.log( "SELECTIONS:", commandsProfileSelection, platformSelection );

    let applyChanges = ()=>
    {
      if ( godot )
      {
        this.godotCommands.selectedPlatform = platformSelection.selectedOptions[ 0 ].value as Platform;
        this.godotCommands.selectedProfile  = commandsProfileSelection.selectedOptions[ 0 ].value as Platform;
        this.applyCommands();
      }

    };

    OnChange.add( commandsProfileSelection, applyChanges );
    OnChange.add( platformSelection, applyChanges );

  }

  static applyGodotOnElement( e:Element )
  {
    let pe = ( e as ProcessedActionElement );
    let commandName = e.textContent;

    if ( pe._action )
    {
      commandName = ( e as ProcessedActionElement )._action;
    }

    pe._action = commandName;

    
    let command = AppCommandElements.godotCommands.getCommand( commandName );

    if ( ! command )
    {
      console.log( "Command not found:", commandName, AppCommandElements.godotCommands );

      return;
    }

    let interaction = command.getForPlatform( AppCommandElements.godotCommands.selectedPlatform );

    if ( ! interaction )
    {
      return;
    }
    
    e.innerHTML = "";
    ElementAttribute.title.to( e, commandName );

    let lastWasKB = false;

    interaction.inputs.forEach(
      ( input )=>
      {
        let target = input.target;
        let isKB = false;
        if ( InputDeviceTypes.Keyboard == input.inputDevice )
        { 
          isKB = true;
          if ( ModifierKeys.isModifierKey( target ) )
          {
            target = ModifierKeys.getKeyFor( target as ModifierKey, AppCommandElements.godotCommands.selectedPlatform );
          }
        }

        let inputAction = AppCommandElements.inputAction.create( target );

        
        AppCommandElements.actionAttribute.to( inputAction, input.action );
        AppCommandElements.deviceAttribute.to( inputAction, input.inputDevice );

        if ( isKB && lastWasKB )
        {
          let kiu = Rokojori.$.templatesManager.createTemplate( AppCommandElements.keyboardInputUnion.selector );
          e.appendChild( kiu );
        }

        e.appendChild( inputAction );

        lastWasKB = isKB;
      }
    )

  }
}